import React from "react";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import DefaultItem from "components/items/default-item";
import { isConfiguredIdentifyingGenderCodeSetType, isConfiguredIdentifyingPronounCodeSetType } from "app/auth/store/reducers/system-configuration";

const identifyingGenderLabel = "Gender";
const identifyingPronounLabel = "Pronouns";

/**
 * Displays patient gender and pronoun fields when enabled by system configuration.
 *
 * NOTE: This component uses DefaultItem directly instead of the TextLabel wrapper
 * because TextLabel is defined inline in the parent patient-details/index.js, which
 * also re-exports this component. Importing TextLabel from there would create a
 * circular dependency. The DefaultItem props below mirror the TextLabel pattern
 * (className, labelClassName, labelProps, textColor).
 *
 */
const PatientGenderAndPronouns = ({ patient }) => {
  const showIdentifyingGender = useSelector(state => isConfiguredIdentifyingGenderCodeSetType(state));
  const showIdentifyingPronoun = useSelector(state => isConfiguredIdentifyingPronounCodeSetType(state));

  if (!patient) return null;

  const { genderDescription, pronounDescription } = patient;
  if (isEmpty(genderDescription) && isEmpty(pronounDescription)) return null;

  const content = textContent => (
    <Typography
      className="cursor-default"
      color="inherit"
      variant="body1"
    >
      {textContent}
    </Typography>
  );

  return (
    <>
      {showIdentifyingGender && !isEmpty(genderDescription) && (
        <DefaultItem
          label={identifyingGenderLabel}
          className="flex-wrap sm:flex-no-wrap"
          labelClassName="w-auto mr-4"
          labelProps={{ variant: "body1" }}
          content={content(genderDescription)}
          textColor="inherit"
        />
      )}

      {showIdentifyingPronoun && !isEmpty(pronounDescription) && (
        <DefaultItem
          label={identifyingPronounLabel}
          className="flex-wrap sm:flex-no-wrap"
          labelClassName="w-auto mr-4"
          labelProps={{ variant: "body1" }}
          content={content(pronounDescription)}
          textColor="inherit"
        />
      )}
    </>
  );
};

export default PatientGenderAndPronouns;
